import { ESeoActionType, TSeoAction } from '../actions/seo';
import { ISeo } from '../types/seo';

export function seoReducer(state: ISeo, action: TSeoAction): ISeo {
  switch (action.type) {
    case ESeoActionType.SetPageData:
      return {
        ...state,
        pageData: action.payload,
      };
    default:
      return state || {};
  }
}
